// extracted by mini-css-extract-plugin
export default {"btn":"btn__-NN-u","menu-item":"menu-item__Fzu5L","popper":"popper__Ovx8j"};